jQuery(function($) {

	// table handles
	$('.chtpc-content table').on('click', function(e) {
		if ( e.target.tagName.toLowerCase() != 'a' && e.target.tagName.toLowerCase() != 'button' && e.target.tagName.toLowerCase() != 'img' ) {
			modalContainer( $(this).prop('outerHTML') );
		} else {
			return false;
		}
	});

	// image handles
	$('.chtpc-content img').on('click', function(e) {
		var $this = $(this);
		var src = "";
		if ( $this.attr('srcset') ) {
			var srcset = $this.attr('srcset').split(', ');
			src = srcset.pop().split(' ')[0];
		} else {
			src = $this.attr('src');
		}
		console.log(src);
		$props = {
			'src': src,
			'alt': $this.attr('alt'),
			'title': ( $this.attr('title') ) ? $this.attr('title') : $this.attr('alt')
		};
		modalImgPreview( $props );
	});

	function modalContainer( $content ) {
		var modal = `
			<div class="modal" style="display: none;">
				<div class="container">
					<div class="modal-controls">
						<span class="modal-close fa fa-times" aria-label="close"></span>
					</div>
					<div class="modal-dialog">
						<div class="modal-body">
							` + $content + `
						</div>
					</div>
				</div>
			</div>
		`;
		$('body').prepend( modal );
		openModal();
	}

	function modalImgPreview( $props ) {
		var modal = `
			<div class="modal" style="display: none;">
				<div class="container">
					<div class="modal-controls">
						<span class="modal-close modal-clear-after fa fa-times" aria-label="close"></span>
					</div>
					<div class="modal-dialog modal-img-preview">
						<img src="` + $props.src + `" alt="` + $props.alt + `" title="` + $props.title + `" />
					</div>
				</div>
			</div>
		`;
		$('body').prepend( modal );
		openModal();
	}

	$(document).on('click', '.modal .modal-close', function(e) {
		e.preventDefault();
		if ( $(this).hasClass('modal-clear-after') ) {
			closeModal( true );
		} else {
			closeModal();
		}
		
	});

	$(document).click(function (e) {
	    if ($(e.target).is('.modal')) {
	        $('#openModal').fadeOut(500);
	    }
	});

	function openModal() {
		$('.modal').fadeIn('fast', function() {
			$('body').addClass('modal-active');
		});
		return;
	}

	function closeModal( clearAfter = null ) {
		$('.modal').fadeOut('fast', function() {
			if ( clearAfter ) {
				$(this).remove();
			}
			$('body').removeClass('modal-active');
		});
		return;
	}

	// outside clicks handle
	$(document).on('click', function(e) {
		var $this = $(e.target);
		if ( $this.hasClass('modal') ) {
			closeModal();
		}
	});

	$('[data-trigger="modal"]').on('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		var target = $this.data('target');

		$('#'+target).fadeIn('fast', function() {
			$('body').addClass('modal-active');
		});
		
	});

});